import { type FC, type ReactNode, useMemo, useState } from "react";
import { TopMenuContext } from "../contexts/TopMenuContext";

export const TopMenuProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [topMenuHeight, setTopMenuHeight] = useState(0);
  const [topMenuWidth, setTopMenuWidth] = useState(0);

  const value = useMemo(
    () => ({
      setTopMenuHeight,
      setTopMenuWidth,
      topMenuHeight,
      topMenuWidth,
    }),
    [topMenuHeight, topMenuWidth],
  );

  return (
    <TopMenuContext.Provider value={value}>{children}</TopMenuContext.Provider>
  );
};
